import { BaseModel } from './base.model';

export class AcademicSegment extends BaseModel {
  id: string;
  key: number;
  name: string;
}
